import { isRef, onMounted, onUnmounted, unref, watch, type Ref } from 'vue';

/**
 * Abonne un écouteur DOM sur toute la durée de vie du composant.
 *
 * Accepte une `ref` de cible : l'écouteur suit les remplacements d'élément, ce
 * qui évite les fuites au re-rendu.
 */
export function useNativeEvent(
	target: EventTarget | Ref<EventTarget | null | undefined> | null | undefined,
	eventName: string,
	callback: (...args: any[]) => any,
	options?: AddEventListenerOptions | boolean,
): void {
	let current: EventTarget | null = null;

	const add = (element: EventTarget | null | undefined) => {
		if (element) {
			current = element;
			element.addEventListener(eventName, callback, options as any);
		}
	};
	const remove = () => {
		if (current) {
			current.removeEventListener(eventName, callback, options as any);
			current = null;
		}
	};

	if (isRef(target)) {
		watch(target, (value) => {
			remove();
			add(value);
		});
	}

	onMounted(() => add(unref(target)));
	onUnmounted(remove);
}
